// extracted by mini-css-extract-plugin
export default {"title":"ypVq9","leftAligned":"_1Wmqc"};